export default function VideoSection(){
    return(
        <>
           <div className="video-section">
<h2 className="section-title">Our PG Room View</h2>
<div className="video-container">

  <div className='row container-fluid'>
     <div class="col-12 col-md-6 col-lg-4">
     <iframe width="100%" height="315" src="https://www.youtube.com/embed/0kf9mJUBM8M" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
     </div>

     <div class="col-12 col-md-6 col-lg-4">
     <iframe width="100%" height="315" src="https://www.youtube.com/embed/E4YpgjhwE9M" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
     </div>

     <div class="col-12 col-md-6 col-lg-4">
     <iframe width="100%" height="315" src="https://www.youtube.com/embed/k1pO7qa989Y" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
     </div>

  </div>


</div>
</div>
        
        </>
    )
}